import React from "react";

const MechIcon = ({ className }) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_229_24060)">
      <rect
        x="1.04102"
        y="13.5166"
        width="17.6758"
        height="6.44648"
        rx="3.11927"
        fill="white"
      />
      <circle cx="9.98324" cy="7.90218" r="4.15902" fill="#FF5500" />
      <path
        d="M10.3282 16.7467C10.1633 16.9914 9.80312 16.9914 9.63827 16.7467L7.89859 14.1639C7.71251 13.8877 7.91046 13.5157 8.24354 13.5157H11.7229C12.056 13.5157 12.2539 13.8877 12.0678 14.1639L10.3282 16.7467Z"
        fill="#FF5500"
      />
    </g>
    <rect
      x="0.207951"
      y="0.207951"
      width="19.3394"
      height="19.3394"
      rx="9.66972"
      stroke="#FF5500"
      stroke-width="0.415902"
    />
    <defs>
      <clipPath id="clip0_229_24060">
        <rect width="19.7554" height="19.7554" rx="9.87768" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default MechIcon;
